










import {IFilterItem} from '../../models/filter-item-model';
import Checkbox from './Checkbox.vue'
import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
    name: 'CheckboxList',
    components: { Checkbox },
    props: {
        filters: { type: Array as PropType<IFilterItem[]> },
        filterGroup: { type: String, required: true },
        filterGroupTitle: { type: String, required: true }
    },
    methods: {
        trackCheckboxOptionsClick(payload: { codename: string; checked: boolean; label: string }) {
            const interaction = payload.checked ? "check_filter" : "uncheck_filter";

            if (typeof window !== "undefined" && (window as any).dataLayer) {
                const cleanFilterName = this.normalizeFilterName(this.filterGroupTitle);
                
                const eventData: Record<string, any> = {
                    event: "search_filter",
                    interaction_type: interaction,
                    content_filter_selection: payload.label
                };

                // Only include content_filter if it exists
                if (cleanFilterName) {
                    eventData.content_filter = cleanFilterName;
                }

                (window as any).dataLayer.push(eventData);
            }

            this.$emit("filterChanged", payload.codename);
        },
        // To remove the number of checked content_filter_selection. IE: content_filter (1)
        normalizeFilterName(name: string | null): string | null {
            if (!name) return null;
            return name.replace(/\s\(\d+\)$/, '');
        }
    }
})
